import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetDataFlowFailedMessageResData extends ApiGenericResponse {
    rayId: string;
    failedMessage: string;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    parse(obj: any) {
        if (obj.rayId) this.rayId = obj.rayId;
        if (obj.message) this.failedMessage = obj.message;
    }
}
